import { Component, OnInit, HostListener } from '@angular/core';
import { Constants } from '../../data/constants/constants';
import { Helper } from '@linkdev/shared-library';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  twitterAccount: any;
  translation: any;
  facebookAccount: any;
  youtubeAccount: any;
  FAQsLink: any;
  aboutUsLink: any;
  contactUsLink: any;
  lawsLink: any;
  currentYear: number = new Date().getFullYear();
  isMobileView: boolean = window.innerWidth < 992;
  menuItems: any[];

  constructor(private translateService: TranslateService) {
    this.translateService.get("footer").subscribe((trans) => {
      this.translation = trans;
    });
    this.twitterAccount = Constants.socialMediaAccounts.twitter;
    this.youtubeAccount = Constants.socialMediaAccounts.youtube;
    this.facebookAccount = Constants.socialMediaAccounts.facebook;
    this.FAQsLink = Constants.contentPages.faqs;
    this.aboutUsLink = Constants.contentPages.aboutUs;
    this.contactUsLink = Constants.contentPages.contactUs;
    this.lawsLink = Constants.contentPages.laws;
    if (this.GetCurrentLanguage() == 'en') {
      this.menuItems = [
        {
          showInFooter: true,
          nodeName: 'Browse',
          redirectToPage: true,
          expanded: false,
          children: [
            {
              showInFooter: true,
              nodeName: 'About SSA',
              redirectToPage: true,
              url: "https://ssa.gov.sa/en/informativeContentPage/?path=/about-ssa/",
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'Partnerships',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/partnershipLanding/?path=/partnerships-landing-page/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'Media Center',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/news/?path=/news/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'Open Data',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/openDataContentPages/?path=/introduction-to-open-data/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'FAQs',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/collapseReusablePage/?path=/faqs/',
              target: 'New Tab',
            }
          ],
        },
        {
          showInFooter: true,
          nodeName: 'Help & Support',
          redirectToPage: true,
          expanded: false,
          children: [
            {
              showInFooter: true,
              nodeName: 'Terms of Use',
              redirectToPage: true,
              url: "https://ssa.gov.sa/en/contentTemplate/?path=/terms-of-use/",
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'Privacy Policy',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/contentTemplate/?path=/privacy-policy/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'Freedom of Information Policy',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/contentTemplate/?path=/freedom-of-information-policy/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'E-Participation',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/informativeContentPage/?path=/e-participation/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'Careers',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/en/careersLandingPage/?path=/careers/',
              target: 'New Tab',
            }
          ],
        },
      ];
    }
    else {
      this.menuItems = [
        {
          area: 'A',
          showInFooter: true,
          nodeName: 'تصفح',
          redirectToPage: true,
          expanded: false,
          children: [
            {
              showInFooter: true,
              nodeName: 'من نحن',
              redirectToPage: true,
              url: "https://ssa.gov.sa/ar/informativeContentPage/?path=/about-ssa/",
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'الشراكات',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/partnershipLanding/?path=/partnerships-landing-page/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'المركز الاعلامي',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/news/?path=/news/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'البيانات المفتوحة',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/openDataContentPages/?path=/introduction-to-open-data/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'الاسئلة الشائعة',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/collapseReusablePage/?path=/faqs/',
              target: 'New Tab',
            }
          ],
        },
        {
          area: 'B',
          showInFooter: true,
          nodeName: 'المساعدة والدعم',
          redirectToPage: true,
          expanded: false,
          children: [
            {
              showInFooter: true,
              nodeName: 'شروط الاستخدام',
              redirectToPage: true,
              url: "https://ssa.gov.sa/ar/contentTemplate/?path=/terms-of-use/",
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'سياسة الخصوصية',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/contentTemplate/?path=/privacy-policy/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'سياسة حرية المعلومات',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/contentTemplate/?path=/freedom-of-information-policy/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'المشاركة الالكترونية',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/informativeContentPage/?path=/e-participation/',
              target: 'New Tab',
            },
            {
              showInFooter: true,
              nodeName: 'الوظائف',
              redirectToPage: true,
              url: 'https://ssa.gov.sa/ar/careersLandingPage/?path=/careers/',
              target: 'New Tab',
            }
          ],
        },
      ];
    }

  }

  ngOnInit() {
    this.updateExpandedState();
  }
  GetCurrentLanguage() {
    return Helper.getCookieValue('lang');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileView = window.innerWidth < 992;
    this.updateExpandedState();
  }

  updateExpandedState() {
    this.menuItems.forEach(item => {
      if (window.innerWidth >= 992) {
        item.expanded = true;
      } else {
        item.expanded = false;
      }
    });
  }

  toggleSubMenu(item: any) {
    if (this.isMobileView) {
      item.expanded = !item.expanded;
    }
  }
  trackByIndex(index: number): number {
    return index;
  }
   
}
